module.exports = __webpack_public_path__ + "img/exclamation-circle-solid-yellow.8733330c.svg";